<template>
  <b-row class="justify-content-center">
    <b-col
      lg="3"
      md="3"
      sm="12"
      order="1"
    >
      <b-row class="justify-content-between h-100">

        <b-col
          cols="12"
        >
          <b-card
            class="bg-success content-center cursor-pointer card-justify"
            :class="{'bg-warning': order.infectious}"
            @click="toggleShowOrderStatusChanger"
          >
            <div
              class="d-md-flex align-items-center card-justify w-100 text-primary text-center"
            >
              <rc-overlay
                :show="loading"
                rounded
                class="mx-auto"
                :class="{'position-absolute position-top-0 position-right-0 position-bottom-0 position-left-0': loading}"
              >
                <div
                  v-show="!loading"
                  class="w-100"
                >
                  <div class="text-white text-center font-large-1">
                    {{ $t('order.status.' + order.status) }}
                  </div>
                  <div
                    v-if="order.infectious && !isMedicalCourier"
                    class="text-white text-center font-medium-3"
                  >
                    <feather-icon icon="AlertTriangleIcon" />
                    ZAKAŹNE
                  </div>
                  <div
                    v-else-if="!isEventOrder && !isMedicalCourier"
                    class="text-white text-center font-medium-3"
                  >
                    {{ $t('order.no-danger') }}
                  </div>
                  <div
                    v-if="order.prioritySignals"
                    class="text-white text-center font-medium-4 mt-2 font-weight-bolder"
                  >
                    <b-avatar
                      size="24"
                      variant="primary"
                      class="mr-25 mt-0"
                    >
                      <feather-icon
                        icon="LoaderIcon"
                        class="font-medium-2"
                      />
                    </b-avatar>
                    {{ $t(`order.priority-signals.${order.prioritySignals}`) }}
                  </div>
                </div>
              </rc-overlay>
            </div>
          </b-card>
        </b-col>

        <b-col v-if="order.private">
          <statistic-card-horizontal
            icon="DollarSignIcon"
            :statistic="order.amountGross + ' zł'"
            :statistic-title="$t('order.label.base-order-info.payment-method-' + order.paymentMethod)"
            color="success"
            class="card-justify"
          />
        </b-col>

      </b-row>
    </b-col>

    <b-col
      v-if="!isEventOrder"
      cols="12"
      md="4"
      order="3"
      order-md="2"
    >
      <b-row class="justify-content-between h-100">

        <b-col>

          <b-card
            class="card-justify"
          >
            <div>
              <h4 class="mb-0">
                {{ pickupCardTitle }}
                <b-dropdown
                  v-if="showManualRouteSortInPickupCard"
                  class="float-right mt-n50 mr-n1"
                  right
                  size="sm"
                  variant="flat-secondary"
                  no-caret
                  toggle-class="btn btn-flat-primary btn-sm"
                >
                  <template #button-content>
                    <feather-icon icon="MoreVerticalIcon" />
                  </template>

                  <b-dropdown-item @click="openManualRouteSortModal">
                    {{ $t('order.route-sorting.actions.open') }}
                  </b-dropdown-item>
                </b-dropdown>
              </h4>
              <b-badge
                v-if="showManualRouteSortBadgeInPickupCard"
                variant="light-warning"
                class="mt-25"
              >
                {{ $t('order.route-sorting.badge') }}
              </b-badge>
            </div>

            <rc-overlay :show="loading">
              <div class="mt-1">
                <app-timeline
                  v-if="showPickupTimeline"
                  class="mt-1"
                >
                  <app-timeline-item
                    v-for="item in pickupTimelineItems"
                    :key="item.key"
                    :title="item.title"
                    :subtitle="item.subtitle"
                    :variant="item.variant"
                  />
                </app-timeline>

                <div
                  v-else
                  class="text-center text-md-right"
                >
                  <div>
                    <h4>
                      {{ order.pickupAddress.name }}
                    </h4>
                    <h5
                      v-if="order.pickupAddressDetails"
                      class="mt-n25"
                    >
                      {{ order.pickupAddressDetails.value }}
                    </h5>
                    <div class="mt-n50 mb-50">
                      <small
                        v-if="order.pickupAddress.alias"
                        class="text-muted text-uppercase"
                      >
                        @{{ order.pickupAddress.alias }}
                      </small>
                    </div>
                  </div>
                  <p class="mb-0">
                    {{ order.pickupAddress.address }}
                  </p>
                  <p class="mb-0">
                    {{ order.pickupAddress.zip }} {{ order.pickupAddress.city }}
                  </p>
                  <p
                    v-if="order.commissionedBy"
                    class="mb-0"
                  >
                    {{ $t('order.label.base-order-info.commissioned-by') }}: {{ order.commissionedBy }}
                  </p>
                  <p class="mb-0">
                    <i>{{ order.pickupDetails }}</i>
                  </p>
                </div>

                <div
                  v-if="showPickupDate"
                  class="text-center text-md-left mt-1"
                >
                  <h4 class="mb-50">
                    {{ pickupDateTitle }}
                  </h4>
                  <p :class="{ 'text-danger': order.absolutePunctuality, 'font-medium-3': true }">
                    <b-avatar
                      v-if="order.absolutePunctuality"
                      v-b-tooltip="$t('order.label.base-order-info.absolute-punctuality')"
                      size="24"
                      variant="danger"
                      class="mr-25 mt-0"
                    >
                      <feather-icon
                        icon="ClockIcon"
                        class="font-medium-2"
                      />
                    </b-avatar>
                    {{ transformDatetimeToHumanReadablePretty(order.startAt) }}
                  </p>
                </div>
              </div>
            </rc-overlay>

          </b-card>
        </b-col>

      </b-row>
    </b-col>

    <b-col
      v-if="!isEventOrder"
      md="1"
      order="4"
      order-md="3"
    >
      <div
        v-if="order.id"
        class="d-flex align-items-center card-justify w-100 text-primary text-center"
      >
        <feather-icon
          v-if="order.returnTransport"
          icon="RepeatIcon"
          size="2x"
          class="mx-auto"
        />
        <feather-icon
          v-else
          icon="ArrowRightIcon"
          size="2x"
          class="mx-auto"
        />
      </div>
    </b-col>

    <b-col
      :md="isEventOrder ? 9 : 4"
      order="5"
      :order-md="isEventOrder ? 2 : 4"
    >
      <b-row class="justify-content-between h-100">

        <b-col>
          <b-card
            class="card-justify"
          >
            <div>
              <h4 class="mb-0">
                {{ deliveryCardTitle }}
                <b-dropdown
                  v-if="showManualRouteSortInDeliveryCard"
                  class="float-right mt-n50 mr-n1"
                  right
                  size="sm"
                  variant="flat-secondary"
                  no-caret
                  toggle-class="btn btn-flat-primary btn-sm"
                >
                  <template #button-content>
                    <feather-icon icon="MoreVerticalIcon" />
                  </template>

                  <b-dropdown-item @click="openManualRouteSortModal">
                    {{ $t('order.route-sorting.actions.open') }}
                  </b-dropdown-item>
                </b-dropdown>
              </h4>
              <b-badge
                v-if="showManualRouteSortBadgeInDeliveryCard"
                variant="light-warning"
                class="mt-25"
              >
                {{ $t('order.route-sorting.badge') }}
              </b-badge>
            </div>

            <rc-overlay :show="loading">
              <div class="mt-1">
                <app-timeline
                  v-if="showDeliveryTimeline"
                  class="mt-1"
                >
                  <app-timeline-item
                    v-for="item in deliveryTimelineItems"
                    :key="item.key"
                    :title="item.title"
                    :subtitle="item.subtitle"
                    :variant="item.variant"
                  />
                </app-timeline>

                <div
                  v-else
                  class="text-center text-md-left"
                >
                  <div>
                    <h4>
                      {{ order.deliveryAddress.name }}
                    </h4>
                    <h5
                      v-if="order.deliveryAddressDetails"
                      class="mt-n25"
                    >
                      {{ order.deliveryAddressDetails.value }}
                    </h5>
                    <div class="mt-n50 mb-50">
                      <small
                        v-if="order.deliveryAddress.alias"
                        class="text-muted text-uppercase"
                      >
                        @{{ order.deliveryAddress.alias }}
                      </small>
                    </div>
                  </div>
                  <p class="mb-0">
                    {{ order.deliveryAddress.address }}
                  </p>
                  <p class="mb-0">
                    {{ order.deliveryAddress.zip }} {{ order.deliveryAddress.city }}
                  </p>
                  <p
                    v-if="order.agreedWith"
                    class="mb-0"
                  >
                    {{ $t('order.label.base-order-info.agreed-with') }}: {{ order.agreedWith }}
                  </p>
                  <p class="mb-0">
                    <i>{{ order.deliveryDetails }}</i>
                  </p>
                </div>

                <div
                  v-if="showDeliveryDate"
                  class="text-center text-md-left mt-1"
                >
                  <h5 class="mb-50">
                    {{ realizationDateTitle }}
                  </h5>
                  <p :class="{ 'text-danger': order.absolutePunctuality, 'font-medium-3 mb-0': true }">
                    <b-avatar
                      v-if="order.absolutePunctuality"
                      v-b-tooltip="$t('order.label.base-order-info.absolute-punctuality')"
                      size="24"
                      variant="danger"
                      class="mr-25 mt-0"
                    >
                      <feather-icon
                        icon="ClockIcon"
                        class="font-medium-2"
                      />
                    </b-avatar>
                    {{ transformDatetimeToHumanReadablePretty(order.startAt) }}
                  </p>
                </div>

                <div
                  v-if="isEventOrder"
                  class="text-center text-md-left mt-1"
                >
                  <h5 class="mb-50">
                    {{ $t('order.event-kind.title') }}
                  </h5>
                  <p class="font-medium-3 mb-0">
                    {{ $t('order.event-kind.' + order.eventKind) }}
                  </p>
                </div>

                <div
                  v-if="isEventOrder && eventTimeRange.start"
                  class="text-center text-md-left mt-1"
                >
                  <h5 class="mb-50">
                    {{ $t('order.label.transport-info.event-time-title') }}
                  </h5>
                  <p class="font-medium-3 mb-0">
                    {{ eventTimeRange.start }}
                    <span v-if="eventTimeRange.end">
                      -
                      <span v-if="eventTimeRange.sameDayTime">
                        {{ eventTimeRange.endTimeOnly }}
                      </span>
                      <span v-else>
                        {{ eventTimeRange.end }}
                      </span>
                    </span>
                  </p>
                </div>
              </div>
            </rc-overlay>

          </b-card>
        </b-col>

      </b-row>
    </b-col>

    <b-col
      order="2"
      order-md="5"
    >
      <order-status-changer
        v-show="showOrderStatusChanger"
        :order="order"
        :workflow="workflow"
        :toggle-show="toggleShowOrderStatusChanger"
        @status-change-response="$emit('status-change-response')"
      />
      <order-manual-route-sort-modal
        ref="manualRouteSortModal"
        :order="order"
        @sorted="$emit('manual-route-sorted')"
      />
    </b-col>
  </b-row>
</template>
<script>
import OrderStatusChanger from '@/views/orders/partials/OrderStatusChanger.vue'
import OrderManualRouteSortModal from '@/views/orders/OrderView/OrderManualRouteSortModal.vue'
import moment from 'moment'
import { transformDatetimeToHumanReadablePretty } from '@/helpers/helpers'
import RcOverlay from '@/layouts/components/rc/RcOverlay.vue'
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import orderTypes from '@/dictionaries/orderTypes'
import { isPatientVisibleInView, patientTransportStatuses, resolvePatientTransportStatus } from '@/helpers/patient'
import { VBTooltip } from 'bootstrap-vue'
import guard from '@/guard'

export default {
  name: 'OrderBasicInfo',
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    RcOverlay,
    StatisticCardHorizontal,
    AppTimeline,
    AppTimelineItem,

    OrderStatusChanger,
    OrderManualRouteSortModal,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showOrderStatusChanger: false,
    }
  },
  computed: {
    order() {
      return this.$store.getters['order/getOrderData']
    },
    workflow() {
      return this.$store.getters['order/getOrderWorkflow']
    },
    isEventOrder() {
      return this.order && this.order.type === orderTypes.event
    },
    isMedicalCourier() {
      return this.order && this.order.type === orderTypes.medical_courier
    },
    isMultiTransport() {
      return this.order && this.order.type === orderTypes.multi_transport
    },
    visiblePatients() {
      if (!Array.isArray(this.order?.patientInfo)) {
        return []
      }

      return this.order.patientInfo.filter(patient => isPatientVisibleInView(patient))
    },
    canManuallySortRoute() {
      return this.isMultiTransport
        && this.visiblePatients.length > 1
        && guard.hasAtLeastOneRole(this.$store.getters['auth/getUser']?.roles || [], ['ROLE_DISPATCHER'])
    },
    isRouteSortedManually() {
      return this.order?.routeOptimizationMode === 'manual'
    },
    showManualRouteSortInPickupCard() {
      return this.canManuallySortRoute && this.showPickupTimeline
    },
    showManualRouteSortInDeliveryCard() {
      return this.canManuallySortRoute && this.showDeliveryTimeline
    },
    showManualRouteSortBadgeInPickupCard() {
      return this.isRouteSortedManually && this.showPickupTimeline
    },
    showManualRouteSortBadgeInDeliveryCard() {
      return this.isRouteSortedManually && this.showDeliveryTimeline
    },
    normalizedMultiTransportDirection() {
      return this.resolveMultiTransportDirection(this.order?.multiTransportDirection)
    },
    pickupTimelineItems() {
      if (!this.isMultiTransport || this.normalizedMultiTransportDirection !== 'inbound') {
        return []
      }
      return this.getPatientTimelineItems('pickup')
    },
    deliveryTimelineItems() {
      if (!this.isMultiTransport || this.normalizedMultiTransportDirection !== 'outbound') {
        return []
      }
      return this.getPatientTimelineItems('delivery')
    },
    showPickupTimeline() {
      return this.pickupTimelineItems.length > 0
    },
    showDeliveryTimeline() {
      return this.deliveryTimelineItems.length > 0
    },
    realizationDateTitle() {
      if (this.isMultiTransport) {
        return this.$t('order.label.transport-info.realization-date-title')
      }
      return this.$t('order.label.transport-info.pickup-date-title')
    },
    pickupDateTitle() {
      return this.realizationDateTitle
    },
    showPickupDate() {
      if (!this.order?.startAt) {
        return false
      }
      if (!this.isMultiTransport) {
        return true
      }
      return this.normalizedMultiTransportDirection === 'outbound'
    },
    showDeliveryDate() {
      if (!this.order?.startAt || !this.isMultiTransport) {
        return false
      }
      return this.normalizedMultiTransportDirection === 'inbound'
    },
    pickupCardTitle() {
      if (!this.isMultiTransport || this.normalizedMultiTransportDirection !== 'inbound') {
        return this.$t('order.label.transport-info.pickup-point-title')
      }
      const count = this.pickupTimelineItems.length
      return this.$tc('order.label.transport-info.pickup-point-title-multi', count, { count })
    },
    deliveryCardTitle() {
      if (this.isMultiTransport && this.normalizedMultiTransportDirection === 'outbound') {
        const count = this.deliveryTimelineItems.length
        return this.$tc('order.label.transport-info.delivery-point-title-multi', count, { count })
      }
      return this.isEventOrder
        ? this.$t('order.label.transport-info.event-location-title')
        : this.$t('order.label.transport-info.delivery-point-title')
    },
    eventTimeRange() {
      const hasStart = !!this.order?.startAt
      const hasEnd = !!this.order?.endAt
      const start = hasStart
        ? this.transformDatetimeToHumanReadablePretty(this.order.startAt)
        : null
      const end = hasEnd
        ? this.transformDatetimeToHumanReadablePretty(this.order.endAt)
        : null

      let sameDayTime = false
      let endTimeOnly = null

      if (hasStart && hasEnd) {
        const startMoment = moment(this.order.startAt)
        const endMoment = moment(this.order.endAt)
        if (startMoment.isValid() && endMoment.isValid() && startMoment.isSame(endMoment, 'day')) {
          sameDayTime = true
          endTimeOnly = endMoment.format('HH:mm')
        }
      }

      return {
        start,
        end,
        sameDayTime,
        endTimeOnly,
      }
    },
  },
  methods: {
    transformDatetimeToHumanReadablePretty,
    resolveMultiTransportDirection(direction) {
      if (!direction) {
        return null
      }

      if (typeof direction === 'string') {
        const normalized = direction.toLowerCase()
        return normalized === 'inbound' || normalized === 'outbound' ? normalized : null
      }

      if (typeof direction === 'object') {
        const possible = [
          direction.value,
          direction.key,
          direction.code,
          direction.name,
          direction.direction,
          direction.id,
        ]
        for (let index = 0; index < possible.length; index += 1) {
          const resolved = this.resolveMultiTransportDirection(possible[index])
          if (resolved) {
            return resolved
          }
        }
      }

      return null
    },
    resolvePatientAddress(patient) {
      if (!patient || typeof patient !== 'object') {
        return null
      }

      return patient.address || null
    },
    formatAddress(address) {
      if (!address) {
        return null
      }
      if (typeof address === 'string') {
        return address
      }
      if (typeof address !== 'object') {
        return null
      }

      const zipCity = [address.zip, address.city].filter(Boolean).join(' ')
      const parts = [address.name, address.address, zipCity].filter(Boolean)
      return parts.length ? parts.join(', ') : null
    },
    formatPatientName(patient, index) {
      const fullName = [patient?.name, patient?.surname].filter(Boolean).join(' ')
      if (fullName) {
        return fullName
      }
      return this.$t('order.patient-info.single-title', { index: index + 1 })
    },
    getTimelineVariant(patient, type, nextPatientId) {
      const patientStatus = resolvePatientTransportStatus(patient)
      if (patientStatus === patientTransportStatuses.notTaken) {
        return 'warning'
      }

      if (this.normalizedMultiTransportDirection === 'inbound') {
        const isCompleted = patientStatus === patientTransportStatuses.onBoard
          || patientStatus === patientTransportStatuses.delivered
        if (isCompleted) {
          return 'success'
        }
        return patient?.id === nextPatientId ? 'primary' : 'secondary'
      }

      if (this.normalizedMultiTransportDirection === 'outbound') {
        if (patientStatus === patientTransportStatuses.delivered) {
          return 'success'
        }
        return patient?.id === nextPatientId ? 'primary' : 'secondary'
      }

      return 'secondary'
    },
    resolveNextPatientIdForTimeline(patients, type) {
      if (!Array.isArray(patients) || patients.length === 0) {
        return null
      }

      if (!this.shouldHighlightNextPatient(type)) {
        return null
      }

      const findFirstByStatuses = statuses => {
        const candidate = patients.find(patient => statuses.includes(resolvePatientTransportStatus(patient)))
        return candidate?.id ?? null
      }

      if (type === 'pickup') {
        return findFirstByStatuses([patientTransportStatuses.pending])
      }

      return findFirstByStatuses([patientTransportStatuses.onBoard, patientTransportStatuses.pending])
    },
    shouldHighlightNextPatient(type) {
      const status = this.order?.status
      if (!status || !this.isMultiTransport) {
        return false
      }

      if (type === 'pickup') {
        return this.normalizedMultiTransportDirection === 'inbound'
          && ['confirmed', 'on_way_to_pickup_point', 'at_pickup_point'].includes(status)
      }

      return this.normalizedMultiTransportDirection === 'outbound'
        && ['patient_pick_up', 'on_way_to_delivery_point', 'at_delivery_point'].includes(status)
    },
    getPatientTimelineItems(type) {
      const nextPatientId = this.resolveNextPatientIdForTimeline(this.visiblePatients, type)

      return this.visiblePatients
        .map((patient, index) => {
          const title = this.formatAddress(this.resolvePatientAddress(patient))
          if (!title) {
            return null
          }

          return {
            key: patient?.id ?? `timeline-${type}-${index}`,
            title,
            subtitle: this.formatPatientName(patient, index),
            variant: this.getTimelineVariant(patient, type, nextPatientId),
          }
        })
        .filter(Boolean)
    },
    openManualRouteSortModal() {
      const modal = this.$refs.manualRouteSortModal
      if (modal && typeof modal.open === 'function') {
        modal.open()
      }
    },
    toggleShowOrderStatusChanger() {
      if (!this.loading) {
        this.showOrderStatusChanger = !this.showOrderStatusChanger
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.card-justify {
  height: calc(100% - 2rem) !important;
}
</style>
